import { sendRequest } from '../../config';

export interface dataPolicies {
    insured: Insured;
    products: Product[];
    benefits: Benefit[];
    plans: Plan[];
    locatortypesbyproduct: LocatorTypesByProduct[];
    locatortypesbybenefit: LocatorTypesByBenefit[];
    insurers: Insurer[];
    clients: Client[];
    clientsbyinsurer: ClientsByInsurer[];
    insurersbyproduct: InsurersByProduct[];
    insurersbybenefit: InsurersByBenefit[];
    clientsbyproductinsurer: ClientsByProductInsurer[];
    clientsbybenefitinsurer: ClientsByBenefitInsurer[];
    policies: Policy[];
    description: string;
}

export interface Policy {
    insurerid: string;
    clientid: string;
    policynumber: string;
    holderid: string;
    inactit: string;
    xtitular: string;
    xtitular_ap: string;
    fnacimi_t: string;
    isexo_t: string;
    holdertype: string;
    validfrom: string;
    validto: string;
    insurername: string;
    clientname: string;
    plans: Plan[];
    products: Product[];
    benefits: Benefit[];
    plansbyproduct: PlansByProduct[];
    plansbybenefit: PlansByBenefit[];
    productsbyplan: ProductsByPlan[];
    benefitsbyplan: BenefitsByPlan[];
    locatortypesbyplan: LocatorTypesByPlan[];
    locatortypesbyproduct: LocatorTypesByProduct2[];
    locatortypesbybenefit: LocatorTypesByBenefit2[];
}

export interface Insured {
    id: string;
    idtype: string;
    firstname: string;
    lastname: string;
    fullname: string;
    birthdate: string;
    gender: string;
    email: string | null;
    phone: string | null;
    lastupdate: string;
}

export interface getPoliciesParams {
    cpais: string;
    ccedasegurado: string;
    publicacionplanestipoloc?: string;
}


export const getPolicies = async (params: getPoliciesParams): Promise<dataPolicies> => {
    const ENDPOINT = 'v2/cartera/Policies';
    return sendRequest({
        method: 'post',
        path: ENDPOINT,
        body: params,
    });
};

interface BaseEntity {
    id: string;
    name: string;
}

export interface Product extends BaseEntity { }
export interface Benefit extends BaseEntity { }
export interface Plan extends BaseEntity { }
export interface Insurer extends BaseEntity { }
export interface Client extends BaseEntity { }

export interface LocatorType {
    code: string;
    name: string;
}

export interface LocatorTypesByProduct {
    productid: string;
    types: LocatorType[];
}

export interface LocatorTypesByBenefit {
    benefitid: string;
    types: LocatorType[];
}

export interface ClientsByInsurer {
    insurerid: string;
    clients: Client[];
}

export interface InsurersByProduct {
    productid: string;
    insurers: Insurer[];
}

export interface InsurersByBenefit {
    benefitid: string;
    insurers: Insurer[];
}

export interface ClientsByProductInsurer {
    productid: string;
    insurerid: string;
    clients: Client[];
}

export interface ClientsByBenefitInsurer {
    benefitid: string;
    insurerid: string;
    clients: Client[];
}

export interface PlansByProduct {
    productid: string;
    productname: string;
    plans: Plan[];
}

export interface PlansByBenefit {
    benefitid: string;
    benefitname: string;
    plans: Plan[];
}

export interface ProductsByPlan {
    planid: string;
    planname: string;
    products: Product[];
}

export interface BenefitsByPlan {
    planid: string;
    planname: string;
    benefits: Benefit[];
}

export interface LocatorTypesByPlan {
    planid: string;
    planname: string;
    types: LocatorType[];
}

export interface LocatorTypesByProduct2{
    productid: string;
    productname: string;
    types: LocatorType[];
}
export interface LocatorTypesByBenefit2{
    benefitid: string;
    benefitname: string;
    types: LocatorType[];
}
